const baseURL = process.env.REACT_APP_API_URL;
console.log(baseURL);
export const ApiNames = {
  USER_AUTH: `${baseURL}/user/auth`,
  USER_SIGNUP: `${baseURL}/user/signup`,
  USER_ACTIVATION: `${baseURL}/user/activation`,
  USER_FORGOTPASS: `${baseURL}/user/forgotPassword`,
  USER_RESET: `${baseURL}/user/resetPassword`,
  ADD_USER: `${baseURL}/user/add`,
  USER_SIGNIN: `${baseURL}/user/signin`,
  USER_SIGNOUT: `${baseURL}/user/signout`,
  USER_LIST: `${baseURL}/user/list`,
  USER_EXIST: `${baseURL}/user/exist`,
  ORGANIZATION_LIST: `${baseURL}/user/org/list`,
  USER_UPDATE: `${baseURL}/user/update`,
  USER_DELETE: `${baseURL}/user/delete`,
  ADD_ORGANIZATION: `${baseURL}/organization/add`,
  LIST_ORGANIZATION: `${baseURL}/organization/fetch`,
  LIST_SCANS: `${baseURL}/scan/list`,
  DELETE_SCAN: `${baseURL}/scan/delete`,
  FETCH_PAGE_DATA_SCAN: `${baseURL}/scan/pagedata`,
  FETCH_OUTBOUND_LINK_SCAN: `${baseURL}/scan/outbound`,
  FETCH_THIRD_PARTY_SCAN: `${baseURL}/scan/third`,
  FETCH_A11Y_SCAN: `${baseURL}/scan/a11y`,
  FETCH_LIGHTHOUSE_CATEGORY_SCAN: `${baseURL}/scan/lighthouse`,
  FETCH_CSP_SCAN: `${baseURL}/scan/websecurity/csp`,
  FETCH_PSHTT_SCAN: `${baseURL}/scan/websecurity/pshtt`,
  FETCH_SSLYZE_SCAN: `${baseURL}/scan/websecurity/sslyze`,
  FETCH_ANALYTICS_SCAN: `${baseURL}/scan/analytics/analy`,
  FETCH_DAP_SCAN: `${baseURL}/scan/analytics/dap`,
  FETCH_GOV_ANALYTICS_SCAN: `${baseURL}/scan/analytics/gov`,
  FETCH_SEARCH_ENGINE_LHD_SCAN: `${baseURL}/scan/searchengine/lighthousedesktop`,
  FETCH_SEO_SCAN: `${baseURL}/scan/searchengine/seo`,
  FETCH_SEARCH_FEATURE_SCAN: `${baseURL}/scan/searchengine/searchfeature`,
  FETCH_SITE_PERFORMANCE_LHD_SCAN: `${baseURL}/scan/siteperformance/lighthousedesktop`,
  FETCH_TRUST_MAIL_SCAN: `${baseURL}/scan/mailserver/trustmail`,
  FETCH_USWDS2_SCAN: `${baseURL}/scan/uswds/uswds2`,
  FETCH_ZAPROXY_SCAN: `${baseURL}/scan/vulnerability/zaproxy`,
  FETCH_WAPPYBIRD_SCAN: `${baseURL}/scan/technology/wappybird`,


  EDIT_ORG_LIST: `${baseURL}/organization/editOrganaizeList`,
  EDIT_ORG_STATUS: `${baseURL}/organization/edit`,
  REFERRENCE_TABLE_CREATE: `${baseURL}/scan/ref/create`,
  REFERRENCE_TABLE_LIST: `${baseURL}/scan/ref/list`,
  COMPLIANCE_TABLE_LIST: `${baseURL}/metabase/complianceDashboard`,
  COMPLIANCE_REPORT_LIST: `${baseURL}/scan/ref/report/list`,
  COMPLIANCE_INDI_REPORT_LIST: `${baseURL}/scan/ref/report/getData`,
  CUSTOM_REPORT_LIST: `${baseURL}/scan/ref/customReport/list`,
   CUSTOM_REPORT_NAME_LIST: `${baseURL}/scan/ref/reportName/list`,
  CUSTOMER_INDI_REPORT_LIST: `${baseURL}/scan/ref/customer/getData`,
  CUSTOM_REPORT_LIST_ALL: `${baseURL}/scan/ref/report/all`,
 CUSTOM_REPORT_DELETE: `${baseURL}/scan/ref/viewType/delete`,
 LAST_SAVED_VIEW_CONFIG: `${baseURL}/scan/ref/view/lastSavedConfig`,
   FETCH_FRAMEWORK_DETAIL: (targetId, frameworkId) =>
    `${baseURL}/targets/${targetId}/compliance/${frameworkId}`,
  FETCH_ALL_FRAMEWORKS: (targetId) =>
    `${baseURL}/targets/${targetId}/compliance`, 
  VIEW_METHOD_GET: `${baseURL}/scan/ref/viewType/list`,
  VIEW_METHOD_UPLOAD: `${baseURL}/scan/ref/viewTypeUpdate`,

   START_SCAN: `${baseURL}/scan/start`,
  START_BULK_SCAN: `${baseURL}/scan/start-bulk`,
  SCAN_PROGRESS: (scanId) => `${baseURL}/scan/progress/${scanId}`,

  DASHBOARD_SCAN: (scanId) => `${baseURL}/dashboard/scan/${scanId}`,

  // Reports APIs
  REPORTS_DETAILED: (scanId, frameworkId) => `${baseURL}/reports/detailed/scan/${scanId}?framework_id=${frameworkId}`,
  REPORTS_SCAN_DELETE: (scanId) => `${baseURL}/reports/scan/${scanId}`,
  GENERATE_REPORT_FROM_SCAN: (scanId) => `${baseURL}/generate-report-from-scan/${scanId}`,

  // Scan Reports APIs
  SCAN_REPORTS: `${baseURL}/scan-reports`,
  SCANS: `${baseURL}/scans`,

  ORGANIZATION_DASHBOARD_DETAILS: `${baseURL}/dashboard/org/:orgId`,
  AI_HUB_FETCH_CACHED_AI_DATA: (scanId, tab) => `${baseURL}/aiHub/fetch-cached-ai-data/${scanId}/${tab}`,
  AI_HUB_INTERPRETER: (scanId, role) => `${baseURL}/aiHub/ai-interpreter/${scanId}/${role}`,
  AI_HUB_GENERATE_POAM: (scanId) => `${baseURL}/aiHub/generate-poam/${scanId}`,
  AI_HUB_GENERATE_POAM_EXCEL: (scanId) => `${baseURL}/aiHub/generate-poam-excel/${scanId}`,
  AI_HUB_GENERATE_RISK_DIAL: (scanId) => `${baseURL}/aiHub/generate-risk-dial/${scanId}`,
  AI_HUB_ISSUE_SOLVER: (scanId, prompt) => `${baseURL}/aiHub/issue-solver/${scanId}/${prompt}`,
  AI_HUB_REPORT_GEN: (scanId, type) => `${baseURL}/aiHub/generate-report/${scanId}/${type}`,
  AI_HUB_ZERO_TRUST: (scanId) => `${baseURL}/aiHub/zero-trust-alignment/${scanId}`,
  AI_HUB_DRIFT_DETECTOR: (scanId) => `${baseURL}/aiHub/drift-detector/${scanId}`,
  AI_HUB_WHAT_CHANGED: (scanId, otherScanId) => `${baseURL}/aiHub/what-changed/${scanId}/${otherScanId}`,
  AI_HUB_PAST_SCANS_URL_BY_SCAN_ID: (scanId) => `${baseURL}/aiHub/past-scans-url-by-scan-id/${scanId}`,
  AI_HUB_SIMULATOR: (scanId, attackType) => `${baseURL}/aiHub/simulator/${scanId}/${attackType}`,
  AI_HUB_FORECAST: (scanId) => `${baseURL}/aiHub/forecast/${scanId}`,
  AI_HUB_EMAIL_GEN: (scanId, emailType) => `${baseURL}/aiHub/generate-email/${scanId}/${emailType}`,
  AI_HUB_CORRELATION: (scanId) => `${baseURL}/aiHub/correlation/${scanId}`,


   USER_ME: `${baseURL}/user/me`,
  
    // Settings APIs
    USER_CHANGE_PASSWORD: `${baseURL}/user/change-password`,
    USER_LOGIN_HISTORY: `${baseURL}/user/login-history`,
    
    MAIL_TEMPLATES: `${baseURL}/scan/mailserver/templates`,
  MAIL_TEMPLATE_UPDATE: (id) => `${baseURL}/scan/mailserver/templates/${id}`,


  // Help & Support APIs
  HELP_SUPPORT_VIDEOS: `${baseURL}/help-support/videos`,
  HELP_SUPPORT_VIDEO_UPLOAD: `${baseURL}/help-support/video-upload`,
  HELP_SUPPORT_VIDEO_EDIT: (id) => `${baseURL}/help-support/video/${id}`,
  HELP_SUPPORT_VIDEO_DELETE: (id) => `${baseURL}/help-support/video/${id}`,
  HELP_SUPPORT_IDEAS: `${baseURL}/help-support/ideas`,
  HELP_SUPPORT_IDEA_ADD: `${baseURL}/help-support/idea`,
  HELP_SUPPORT_IDEA_UPDATE: (id) => `${baseURL}/help-support/idea/${id}/status`,
  HELP_SUPPORT_IDEA_DELETE: (id) => `${baseURL}/help-support/idea/${id}`,


  GITHUB_AUTH: `${baseURL}/user/auth/github`,
  LINKEDIN_AUTH: `${baseURL}/user/auth/linkedin`,
  GITHUB_USER_EXIST: `${baseURL}/user/auth/github/exist`,

  GITHUB_SIGNUP: `${baseURL}/user/auth/github/signup`,

  GOOGLE_SIGNIN: `${baseURL}/user/auth/google`,
  GOOGLE_SIGNUP: `${baseURL}/user/auth/google/signup`,
  GOOGLE_EXIST: `${baseURL}/user/auth/google/exist`,
}

export const METABASE={
  adminRoute:'https://mb.bravent.io'
}


export const VIEW_TYPE_MAP = {
  0: 'Table',
  1: 'Grid',
  2: 'Chart',
};

export const VIEW_TYPE_OPTIONS = [
  { label: 'Table', value: 0 },
  { label: 'Grid', value: 1 },
  { label: 'Chart', value: 2 },
];